import {
  GET_GIFT_OPTIONS_SUCCESS,
  REQUEST_GIFT_OPTIONS
} from 'store/ducks/giftoptions/types';

const defaultState = {
  giftOptions: {},
  isLoading: false,
  isLoaded: false
};

export default function giftOptions(state = defaultState, action = {}) {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case REQUEST_GIFT_OPTIONS: {
      return { ...state, isLoading: true };
    }

    case GET_GIFT_OPTIONS_SUCCESS: {
      const { giftOptions } = payload;
      return { ...state, giftOptions, isLoaded: true, isLoading: false };
    }

    default: {
      return state;
    }
  }
}
